import {cloneDeep} from "lodash";
import {Room} from "@/core/api/room.api";
import {cdnImgUrl} from '@/utils/ImageUrl'

export default function camstudyEventListener(room) {
    return store => {
        room.addEventListeners({
            room_data_afterInit: (e) => {
                const r = e.roomData.data
                if(!(Room.isCamStudy())) return

                const userList = cloneDeep(r.roomCamStudy.userList)
                for (const user of userList) {
                    store.commit('camstudy/addUser', user);
                }
                const studyDataList = cloneDeep(r.roomCamStudy.studyDataList)
                for (const studyData of studyDataList) {
                    store.commit('camstudy/addStudyData', {studyData, init:true})
                }
                const stopwatchList = cloneDeep(r.roomCamStudy.stopwatchList)
                for (const stopwatch of stopwatchList) {
                    store.commit('camstudy/addStopwatch', {stopwatch, init:true})
                }
                const userBanList = cloneDeep(r.roomCamStudy.userBanList)
                for (const userBan of userBanList) {
                    store.commit('camstudy/addUserBan', userBan)
                }
                const camStudy = cloneDeep(r.roomCamStudy.camStudy)
                store.commit('camstudy/setCamStudy', camStudy)

                const personSetting = cloneDeep(r.roomCamstudyPersonal.personalSetting)
                store.commit('camstudy/setPersonalSetting', personSetting)

                store.dispatch('camstudy/initCamStudy')

                const hashTagList = cloneDeep(r.roomCamStudy.hashTagList)
                store.commit('camstudy/setHashTagList', hashTagList)

                const roomImagePath = cloneDeep(r.roomCamStudy.roomImagePath)
                store.commit('camstudy/setRoomImagePath', roomImagePath)

                const dDay = cloneDeep(r.roomCamStudy.dDay)
                store.commit('camstudy/setDDayList', dDay)
            },
            room_cstudy_addUser: (e) => {
                const user = cloneDeep(e.data.camStudyUser)
                store.commit('camstudy/addUser', user);
                store.commit('camstudy/addStudyData', {studyData: user?.camStudyUserData, userId: user?.userId});
                store.commit('camstudy/addStopwatch', {stopwatch: user?.stopwatch, userId: user?.userId})
            },
            room_cstudy_changeStopwatchState: (e) => {
                const user = cloneDeep(e.data.camStudyUser)
                const studyData = cloneDeep(user.camStudyUserData)
                const stopwatch = cloneDeep(e.data.stopwatch)
                store.commit('camstudy/addUser', user);
                store.commit('camstudy/addStudyData', {studyData, userId: user?.userId});
                store.commit('camstudy/addStopwatch', {stopwatch, userId: user?.userId})
            },
            room_cstudy_resetStopwatch: (e) => {
                const studyData = cloneDeep(e.data.camStudyUserData)
                const stopwatch = cloneDeep(e.data.stopwatch)
                const userId = e.data.userId
                store.commit('camstudy/addStudyData', {studyData, userId})
                store.commit('camstudy/addStopwatch', {stopwatch, userId})
            },
            room_cstudy_addBanUser: (e) => {
                const banUser = cloneDeep(e.data.camStudyUserBan)
                if (!banUser) {
                    return
                }
                store.commit('camstudy/addUserBan', banUser)
            },
            room_cstudy_removeBanUser: (e) => {
                const banUser = cloneDeep(e.data?.camStudyUserBan)
                if (!banUser) {
                    return
                }
                store.commit('camstudy/removeUserBan', banUser)
            },
            room_cstudy_addUserPoint: (e) => {
                store.commit('camstudy/addUserPoint', e.data)
            },
            room_cstudy_modifyCamStudy: (e) => {
                store.commit('camstudy/changeCamStudyInfo', e.data)
            },
            room_modifyRoomImageUrl: (e) => {
                store.commit('camstudy/setRoomImagePath', e.data?.roomImagePath)
            },
            room_cstudy_modifyUserMyMsg: (e) => {
                store.commit('camstudy/changeMyMsg', e.data)
            },
            room_cstudy_changeUserItemSetting: (e) => {
                store.commit('camstudy/changeStopWatchSetting', e.data)
            },
            room_cstudy_changeUsername: (e) => {
                store.commit('camstudy/changeUsername', e.data)
            },
            room_cstudy_changeUserProfileImage: (e) => {
                store.commit('camstudy/changeUserProfileImage', { userId: e.userId, profileImageUrl: e.data?.profileImagePath ? cdnImgUrl(e.data?.profileImagePath) : '' })
            }
        });
    }
}